export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-100/60 via-background-50 to-accent-100/40 rounded-3xl border border-background-200/80 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
                随时随地，畅享漫画
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                酷漫屋移动端已全面适配！无需下载即可通过手机浏览器畅享下拉式滚动阅读体验。打开浏览器输入酷漫屋网址，海量免费漫画立即开看。日漫韩漫国漫，随时随地免费追更。
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-primary-500 text-white text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors">
                  <i className="ri-android-line"></i>Android 客户端
                </div>
                <div className="inline-flex items-center gap-2 px-5 py-3 rounded-full border-2 border-foreground-200 text-foreground-700 text-sm font-medium whitespace-nowrap cursor-pointer hover:border-foreground-400 transition-colors">
                  <i className="ri-apple-line"></i>iOS 客户端
                </div>
              </div>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-6">
                <div className="flex items-center gap-1.5">
                  <i className="ri-smartphone-line text-primary-500 text-sm"></i>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">移动端优化</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <i className="ri-moon-line text-accent-500 text-sm"></i>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">夜间模式</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <i className="ri-font-size text-secondary-500 text-sm"></i>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">字号调节</span>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative">
                <div className="w-48 h-80 rounded-3xl border-4 border-background-300 overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20colorful%20manga%20reading%20app%20interface%20with%20vertical%20scrolling%20webtoon%2C%20clean%20modern%20UI%2C%20warm%20orange%20and%20cream%20theme%2C%20minimal%20device%20frame%2C%20flat%20illustration%20style&width=480&height=800&seq=app-manga-01&orientation=portrait"
                    alt="酷漫屋移动端阅读界面"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -bottom-3 -right-3 w-16 h-16 rounded-2xl bg-accent-500 flex items-center justify-center">
                  <i className="ri-download-2-line text-white text-2xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}